import { useContext } from 'react'
import { TableContext } from 'Context/Table'
import { KTSVG } from '_metronic/helpers'

interface Prop {
  column: any
  headerRight?: boolean
  additionalStyles?: React.CSSProperties
}

const CustomHeaderColumn: React.FC<Prop> = ({ headerRight, column, additionalStyles }) => {
  const { updateSorting } = useContext(TableContext)
  const headerProps = column.getHeaderProps(column.getSortByToggleProps())
  const isCheckbox = `${headerProps.key ?? ''}`.includes('checkbox')
  const isSortable = column.canSort && !column.disableSortBy

  return (
    <>
      <th
        className={`pt-2 pb-3 position-relative ${headerRight ? 'text-end' : ''} ${
          isSortable ? 'cursor-pointer table-header-sortable' : ''
        }`}
        {...headerProps}
        onClick={() => {
          if (isSortable) {
            updateSorting(column.id, !column.isSortedDesc)
            column.toggleSortBy(!column.isSortedDesc)
          }
        }}
        style={additionalStyles}>
        <span className={isSortable ? 'table-header-sortable-label' : ''}>{column.render('Header')}</span>
        <span
          className={
            isCheckbox
              ? 'd-none pointer-events-none position-absolute right-0'
              : 'position-absolute right-0'
          }>
          {column.isSorted ? (
            column.isSortedDesc ? (
              <KTSVG
                path='/media/icons/duotune/arrows/arr004.svg'
                className='svg-icon-2 svg-icon-primary'
              />
            ) : (
              <KTSVG
                path='/media/icons/duotune/arrows/arr003.svg'
                className='svg-icon-2 svg-icon-primary'
              />
            )
          ) : (
            ''
          )}
        </span>
      </th>
    </>
  )
}

export default CustomHeaderColumn
